module.exports = __webpack_public_path__ + "media/images/products/products/pattern-22f2c6bc24bf09372e21b2683489c5a5.jpg";